/* eslint-disable no-underscore-dangle */
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { onChangeFunctionalAreasFilter } from '../../../ac/onChangeMapFilters';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { FUNCTIONAL_AREAS_FILTER } from '../../../constants/filterStyles';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import LayerFeatureSearch from '../../LayerFeatureSearch/LayerFeatureSearch';
import { searchFunctionalAreaInTiles, highlightFunctionalArea, clearFunctionalAreaHighlight } from '../../../utils/searchFunctionalAreaInTiles';
import styles from '../FilterSidebar.module.css';

const FunctionalAreasFiltersComponent = ({
    mapFilters,
    onChangeFunctionalAreasFilter,
}) => {
    const filter = FUNCTIONAL_AREAS_FILTER;
    let items = filter.items;
    if (filter.style && filter.styleKey) {
        items = getStyleFilterItems(filter.style, filter.styleKey);
    }
    const { reduxPath } = filter;

    return (
        <div>
            {/* Переиспользуемый компонент поиска */}
            <div style={{ padding: '10px' }}>
                <LayerFeatureSearch
                    searchFn={searchFunctionalAreaInTiles}
                    highlightFn={highlightFunctionalArea}
                    clearFn={clearFunctionalAreaHighlight}
                    placeholder={t`ID зоны`}
                    notFoundMessage={t`Функциональная зона не найдена в загруженных данных`}
                    successLabel={t`Найдена`}
                    searchLabel={t`Найти`}
                    resultFields={[ 'id', 'type' ]}
                />
            </div>
            <div className={styles.legHead}>{i18n._(FUNCTIONAL_AREAS_FILTER.title)}:</div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, label, color }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width="2vw"
                                height="2vw"
                                opacity="0.8"
                            />
                            <label htmlFor={value}>{i18n._(label)}</label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type="checkbox"
                                        name="functionalAreas"
                                        id={value}
                                        checked={mapFilters[reduxPath].includes(value)}
                                        value={value}
                                        onChange={onChangeFunctionalAreasFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
            <br/>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeFunctionalAreasFilter })(FunctionalAreasFiltersComponent);

export const FunctionalAreasFilter = withDisplayedLayersCheck(ConnectedComponent, t`Функциональные зоны`);
